<main class="p-grid p-md-offset-2 p-sm-12">        
    <div class="p-md-10">
        <input type="text" (keyup)="search($event)" pInputText placeholder="Search"> 
        <ol>
            <li *ngFor="let blogPost of blogPosts"><a [routerLink]="[blogPost.link]" routerLinkActive="true">{{blogPost.title}}</a></li>
        </ol>
    </div>
</main>